module.exports = __webpack_public_path__ + "img/custom-02.0f92a971.jpg";